angular.module('agreements', ['core'])
    .constant('AgreementConst', {
        eventUpdate: 'agreement.updated',
        orderStatuses: ['PENDING', 'WAITING', 'ACCEPTED', 'CONTRACTED', 'REJECTED', 'STOPPED', 'CANCELLED'],
        timeStatuses: ['PENDING', 'ACTIVE', 'EXPIRED']
    })
    .factory('Agreement', function ($resource) {
        return $resource('crm/api/agreement/:id', {id: '@id'}, {
            table: {method: 'GET', url: 'crm/api/agreement/table', isArray: false},
            tableStatistics: {method: 'GET', url: 'crm/api/agreement/table-statistics', isArray: false},
            tableOrder: {method: 'GET', url: 'crm/api/agreement/table-order', isArray: false},
            tableOrderStatistics: {method: 'GET', url: 'crm/api/agreement/table-order-statistics', isArray: false},
            tableOffer: {method: 'GET', url: 'crm/api/agreement/table-offer', isArray: false},
            tableOfferStatistics: {method: 'GET', url: 'crm/api/agreement/table-offer-statistics', isArray: false},
            tableAll: {method: 'GET', url: 'crm/api/agreement/table-all', isArray: false},
            update: {method: 'PUT'},
            children: {method: 'GET', url: 'crm/api/agreement/:id/children', isArray: true},
            pass: {method: 'PUT', url: '/crm/api/agreement/:id/pass'},
            touches: {method: 'GET', isArray: true, url: '/crm/api/agreement/:id/touches'},
            deleteTouch: {method: 'DELETE', url: '/crm/api/agreement/:id/touches/:userId'},
            addTouchOnly: {method: 'POST', url: '/crm/api/agreement/:id/touches'},
            history: {method: 'GET', isArray: true, url: '/crm/api/agreement/:id/history'},
            allowedStatuses: {method: 'GET', isArray: true, url: '/crm/api/agreement/:id/allowed-statuses'},
            allStatuses: {method: 'GET', isArray: true, url: '/crm/api/agreement/:id/all-statuses'},
        })
    })
    .service('AgreementService', function (modals, $rootScope, Agreement, AgreementConst, Principal) {
        this.customFilters = [
            {value: 'with-files', label: 'z plikami'},
            {value: 'no-files', label: 'bez plików'},
            {value: 'external', label: 'zewnętrzne'},
            {value: 'internal', label: 'wewnętrzne'}
        ]
        if (Principal.hasAnyAuthority(['ROLE_CONTRACT_BGT_READ', 'ROLE_ADMIN'])) {
            this.customFilters.push(
                {value: 'bgtMismatch', label: 'suma BGT różna od kwoty netto'},
                {value: 'bgtMatch', label: 'suma BGT równa kwocie netto'}
            )
        }
        this.statuses = () => ['PENDING']
        this.types = () => ['AGREEMENT', 'ANNEX', 'ORDER']
        this.getTypes = (type) => {
            if(['AGREEMENT', 'ANNEX'].includes(type)) {
                return ['AGREEMENT', 'ANNEX'];
            }
            if(type === 'ORDER') {
                return ['ORDER'];
            }
            if(type === 'OFFER') {
                return ['OFFER'];
            }
            return [];
        }
        this.shouldHaveParent = (type) => ['ANNEX'].includes(type)
        this.shouldHaveSubtype = (type) => ['ANNEX'].includes(type)
        this.shouldHaveFile = (type) => ['AGREEMENT', 'ANNEX'].includes(type)

        this.add = params => {
            let entity = {
                id: null,
                attachments: []
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            modals.open('app/agreements/edit-modal.html', 'AgreementEditController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.open = id => {
            // Agreement.get({id: id}).$promise.then(entity => this.show(entity))
            this.show({id: id})
        }
        this.show = entity => {
            modals.open('app/agreements/show-modal.html', 'AgreementShowController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.select = (filters, options) => {
            return modals.open('app/agreements/select-modal.html', 'AgreementSelectController', {filters: filters, options: options}, {size: 'lg'}, "$ctrl")
        }
        this.delete = entity => {
            return modals.confirmDelete("wybrany rekord", () => Agreement.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(AgreementConst.eventUpdate)));
        }
        this.pass = item => {
            return modals.open('app/agreements/touchable/pass-modal.html', 'AgreementPassController', item, {size: "sm"}, "$ctrl")
        }
        this.deleteTouch = (id, userId) => {
            return modals.confirmDelete("wybrany rekord", () => Agreement.deleteTouch({id: id, userId: userId}).$promise.then(() => $rootScope.$broadcast(AgreementConst.eventUpdate)));
        }
        this.history = entity => {
            return modals.open('app/agreements/touchable/history-modal.html', 'AgreementProcessingController', entity.id, {size: "lg"}, "$ctrl")
        }
        this.addTouchOnly = entity => {
            return modals.open('app/agreements/touchable/add-touch-only-modal.html', 'AgreementAddTouchOnlyController', entity.id, {size: "md"}, "$ctrl")
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: 'ROLE_CONTRACT_MODULE',
            path: '/agreement',
            ico: 'fa fa-fw fa-file-text-o',
            name: 'agreement.menu',
            order: 80,
        })
        NavbarLeftMenu.add({
            authorities: 'ROLE_CONTRACT_MODULE',
            path: '/agreement-order',
            ico: 'fa fa-fw fa-file-text-o',
            name: 'agreement-order.menu',
            order: 81,
        })
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('agreementList', {
                parent: 'app',
                url: '/agreement?{page:int}&{size:int}&{sort:string}&{search:string}&signingDateStart&signingDateEnd&periodStart&periodEnd&category&project&costCenter&costType&bgtProject&bgtGroup&bgtGroups&bgtMissing&customFilter&filter&type&status&clients&accessGroup',
                data: {
                    authorities: ['ROLE_CONTRACT_MODULE'],
                },
                params: {
                    filter: {value: 'all', squash: true},
                    bgtGroups: {array: true, value: [], squash: false},
                    status: {array: true, value: [], squash: false},
                    clients: {array: true},
                    customFilter: {array: true, value: [], squash: false},
                },
                views: {
                    'content@': 'agreementList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Agreement, $stateParams) => Agreement.table(angular.copy($stateParams)).$promise,
                    statistics: (Agreement, $stateParams) => Agreement.tableStatistics(angular.copy($stateParams)).$promise
                }
            })
        $stateProvider
            .state('agreementOrderList', {
                parent: 'app',
                url: '/agreement-order?{page:int}&{size:int}&{sort:string}&{search:string}&signingDateStart&signingDateEnd&periodStart&periodEnd&category&project&costCenter&costType&bgtProject&bgtGroup&bgtGroups&bgtMissing&customFilter&filter&type&status&clients&accessGroup',
                data: {
                    authorities: ['ROLE_CONTRACT_MODULE'],
                },
                params: {
                    filter: {value: 'my', squash: true},
                    bgtGroups: {array: true, value: [], squash: false},
                    status: {array: true, value: [], squash: false},
                    clients: {array: true},
                    customFilter: {array: true, value: [], squash: false},
                },
                views: {
                    'content@': 'agreementOrderList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Agreement, $stateParams) => Agreement.tableOrder(angular.copy($stateParams)).$promise,
                    statistics: (Agreement, $stateParams) => Agreement.tableOrderStatistics(angular.copy($stateParams)).$promise
                }
            })

        $stateProvider.state('agreementShow', {
            parent: 'app',
            url: '/agreement/{id}',
            data: {
                authorities: ['ROLE_CONTRACT_MODULE']
            },
            views: {
                'content@': 'agreementShow'
            },
            resolve: {
                item: (Agreement, $stateParams) => Agreement.get({id: $stateParams.id}).$promise
            }
        });

    })
